
/**
 * @description
 * Inactivity catcher
 * Fix for bug on mobile inactivate tab moment.
 */

var hidden, visibilityChange;
var focusLost = false;
var isMobile = navigator.userAgent.toLowerCase().indexOf('mobile') > -1;

if (typeof document.hidden !== "undefined") {
  hidden = "hidden";
  visibilityChange = "visibilitychange";
} else if (typeof document.msHidden !== "undefined") {
  hidden = "msHidden";
  visibilityChange = "msvisibilitychange";
} else if (typeof document.webkitHidden !== "undefined") {
  hidden = "webkitHidden";
  visibilityChange = "webkitvisibilitychange";
}

function handleVisibilityChange() {
  if (!document[hidden]) {
    if (isMobile) {
      //location.reload();
    }
  }
}

function handleFocus() {
  if (isMobile && focusLost == true) {
    console.log("FOKUS WORK")
    //location.reload();
    // location.assign(location.href);
  }
}

if (typeof document.addEventListener === "undefined" || hidden === undefined) {
  console.log("This source code requires a browser that supports the Page Visibility API.")
  console.warn("This source code requires a browser that supports the Page Visibility API.");
} else {
  // Handle page visibility change
  document.addEventListener(visibilityChange, handleVisibilityChange, false);
  window.addEventListener("focus", handleFocus, false);
  window.addEventListener('blur', function() {
    focusLost = true;
  }, false);
}



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/js/inactivity-handler.js
// module id = 865
// module chunks = 0